import angular from 'angular';
import loanSavedCalculationList from './loanSavedCalculationList';

export default angular
  .module('contactLendingTab.scenes.loanSavedCalculationList', [])
  .component('loanSavedCalculationList', loanSavedCalculationList).name;
